/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Cmspost_Media_Pick1Inputs */

const vi_cmspost_media_pick1 = /** @type {(inputs: Cmspost_Media_Pick1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Chọn ảnh từ thư viện`)
};

/**

* @param {Cmspost_Media_Pick1Inputs} inputs
* @param {{ locale?: "vi" }} options
* @returns {LocalizedString}
*/
const cmspost_media_pick1 = /** @type {((inputs?: Cmspost_Media_Pick1Inputs, options?: { locale?: "vi" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Cmspost_Media_Pick1Inputs, { locale?: "vi" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return vi_cmspost_media_pick1(inputs)
});
export { cmspost_media_pick1 as "cmsPost_media_pick" }